import React, { useEffect, useState } from "react";
import BlogHeading from "./blogHeading";
import { useParams } from "react-router-dom";
import Markdown from "react-markdown";
import "./index.scss";
import BlogMain from "./blogMain";
import { api_strapi } from "../../../../../utils/interface";
import MainLayout from "../../../../../layout/mainLayout";

const BlogRenderer = (props) => {
  const { slug } = useParams();
  const [blogDetails, setBlogDetails] = useState();
  const [blogHead, setBlogHead] = useState();
  useEffect(() => {
    const renderBlog = async () => {
      const response = await api_strapi.get(
        `/blogs?populate=blogHeadingImage.image,blogContent&filters[blogSlug][$eq]=${slug}`
      );

      if (response && response.status === 200) {
        setBlogDetails(response?.data?.data[0].attributes.blogContent);
        setBlogHead(response?.data?.data[0].attributes);
      }
    };

    renderBlog();
  }, [slug]);

  return (
    <>
      <MainLayout>
        <div className="blog-wrapper">
          <div className="blog-content-wrapper">
            <div className="image-container">
              <BlogMain blogHead={blogHead} />
            </div>
            <div className="blog-details">
              <div display={"flex"} flexDirection={"column"}>
                {blogDetails?.map((comp, index) => (
                  <SwitchCaseHandler key={index} comp={comp} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

const SwitchCaseHandler = (comp) => {
  switch (comp?.comp?.__component) {
    case "blog.heading":
      return <BlogHeading blogHeading={comp?.comp?.blogHeading} />;
    // case "blog.blog-image":
    //   return (
    //     <BlogImage
    //       description={Any.imageDescription}
    //       image={Any.image?.data?.attributes?.url}
    //     />
    //   );
    case "blog.blog-rich-text":
      return <Markdown children={comp?.comp?.richtext} className="rich-text" />;

    // case "blog.blog-video":
    //   return (
    //     <BlogVideo
    //       description={Any?.videoDescription}
    //       url={Any.blogVideo?.data?.attributes?.url}
    //     />
    //   );

    default:
      break;
  }
};

export default BlogRenderer;
